import load from 'sdk/report';
import { takeEvery } from 'redux-saga/effects';
import { LOAD } from 'model/report';
import { callAction } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      type: LOAD,
    })
  );
}
